import angular from 'angular';
import uiRouter from 'angular-ui-router';
import infoWidgetComponent from './info-widget.component';

let infoWidgetModule = angular.module('info-widget', [uiRouter])

.component('infoWidget', infoWidgetComponent)

.name;

export default infoWidgetModule;



// WEBPACK FOOTER //
// ./client/app/common/info-widget/info-widget.js